<template>
  <el-card>

    <el-row>
      <el-col :span="18">&nbsp;</el-col>
      <el-col :span="6">
        <el-button v-if="showAdd" type="primary" @click="addCompanyAccount">
          添加公司账户
        </el-button>
        <el-button type="primary" @click="goBack">
          返回
        </el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-col>

        <el-table :data="list">
          <el-table-column prop="id" label="id" width="80px">
            <template slot-scope="scope" >
              {{scope.row.id}}
            </template>
          </el-table-column>

          <el-table-column prop="account" label="账户" width="400px"></el-table-column>

          <el-table-column prop="taxpayer_id_number" label="纳税人识别号"></el-table-column>

          <el-table-column prop="remark" label="备注"></el-table-column>
          
          <el-table-column prop="create_time" label="创建日期">
            <template slot-scope="scope">
              <span>{{scope.row.create_time | parseTime('{y}-{m}-{d}')}}</span>
            </template>
          </el-table-column>

          <el-table-column label="默认值">
            <template slot-scope="scope2">
              <el-switch v-model="scope2.row.is_default" @change="setAccountDefault(scope2.row)" />
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip v-if="showView" content="查看" placement="top-start" effect="light">
                <el-button type="text" @click="viewCompanyAccount(scope.row.id)">
                  <i class="el-icon-view"></i>
                </el-button>
              </el-tooltip>

              <el-tooltip  v-if="showEdit" content="编辑" placement="top-start" effect="light">
                <el-button type="text" @click="editCompanyAccount(scope.row.id)">
                  <i class="el-icon-edit"></i>
                </el-button>
              </el-tooltip>

              <el-tooltip  v-if="showDelete" content="删除" placement="top-start" effect="light">
                <el-button type="text" @click="deleteCompanyAccount(scope.row.id)">
                  <i class="el-icon-delete"></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import { fetchSettingCompanyAccountList } from '@/api/billing'
import { deleteSettingCompanyAccount, fetchSettingCompanyAccountDefault } from '@/api/billing'
import { parseTime } from '@/utils'
export default {
  name: 'setting-company-account-list',
  data() {
    return {
      showView: false,
      showAdd: false,
      showEdit: false,
      showDelete: false,
      company_id: null,
      branch_office_id: null,      
      query: {
        offset: 0,
        limit: 20
      },
      loading: false,
      list: []
    }
  },
  methods:{
    addCompanyAccount: function(){
      this.$router.push({name: 'addSettingCompanyAccount', query: {company_id: this.company_id, branch_office_id: this.branch_office_id}})
    },
    viewCompanyAccount: function(id){
      console.log('viewCompanyAccount: ' + id)
      this.$router.push({name: 'viewSettingCompanyAccount', query: {company_id: this.company_id, branch_office_id: this.branch_office_id, id:id}})
    },
    editCompanyAccount: function(id){
      this.$router.push({name: 'editSettingCompanyAccount', query: {company_id: this.company_id, branch_office_id: this.branch_office_id, id:id}})
    },
    deleteCompanyAccount: function(id){
      console.log('deleteCompanyAccount(): id=' + id )
      deleteSettingCompanyAccount(id)
        .then(resp=>{
          setTimeout(()=>{
            this.$message.success('成功删除公司账户信息')
            this.getList()
          }, 500)
        }).catch(err=>{
          this.$$error_message('err')
        })
    },
    setAccountDefault: function(item) {
      fetchSettingCompanyAccountDefault(item.id)
      .then(res => {
        this.$message.success('默认值设置成功')
        this.getList()
      })
      .catch(err => {
        this.$error_message(err)
      })
    },
    goBack: function(){
      this.$router.go(-1)
    },
    getList: function(){
      this.loading = true
      fetchSettingCompanyAccountList(this.query, this.branch_office_id)
        .then( resp => {
          this.list = resp.results
          this.loading = false
        }).catch( err => {
          this.loading = false
          this.$error_message(err)
        })
    }
  },
  created(){
    if (this.$route.query.company_id === undefined || this.$route.query.company_id === null){
      console.log('missing company_id')      
      this.$router.push('/404')
    }
    this.company_id = this.$route.query.company_id

    if (this.$route.query.branch_office_id === undefined || this.$route.query.branch_office_id === null){
      console.log('missing branch_office_id')
      this.$router.push('/404')
    }
    this.branch_office_id = this.$route.query.branch_office_id

    // 权限检查
    if (!this.$perm(["billing.list_setting_company_account"])) {
      this.$router.push('/401')
    }
    this.showView = true

    if (this.$perm(["billing.create_setting_company_account"])) {
      this.showAdd = true
    }

    if (this.$perm(["billing.update_setting_company_account"])) {
      this.showEdit = true
    }

    if (this.$perm(["billing.delete_setting_company_account"])) {
      this.showDelete = true
    }

    this.getList()
  }
}
</script>